import request from '../utils/request';

/**
 * 获取指定项目的资源API
 *
 * 该函数通过发送GET请求到特定的URL，来获取给定项目和资源ID对应的资源信息
 * 主要用于在项目中查询特定资源的详细信息
 *
 * @param {string} projectId - 项目的唯一标识符
 * @param {string} assetsId - 资源的唯一标识符
 * @returns {Promise} 返回一个Promise对象，包含请求的结果
 */
export function getAssetAPI(projectId, assetsId) {
  // 构造请求URL，包含项目ID和资源ID
  const url = `ddilearner/v1/idp/getAsset/${projectId}/${assetsId}`

  // 发送GET请求到MainService，请求指定项目的资源信息
  return request.MainService({
    url: url,
    method: 'get',
    data: {}
  });
}


/**
 * 保存资源数据的API接口
 *
 * 该函数通过POST方法发送请求到MainService服务，以保存特定项目的资源数据
 * 主要用途是将资源信息更新或保存到服务器，以便在系统中使用或展示
 *
 * @param {Object} params - 包含要保存的资源数据的对象
 * @returns {Promise} 返回一个Promise对象，表示异步操作的结果
 */
export function saveAssetDataAPI(params) {
  // 定义API的URL路径
  const url = `ddilearner/v1/idp/saveAssetData`

  // 发送POST请求到MainService，请求保存指定项目的资源数据
  return request.MainService({
    url: url,
    method: 'post',
    data: params
  });
}


/**
 * 向API发送项目时长数据
 *
 * 该函数通过POST请求向服务器发送有关项目时长的数据，以便进行保存或处理
 * 主要用途是与后端服务交互，将前端收集的项目时长信息传递给后端
 *
 * @param {Object} params - 包含项目时长信息的对象
 * @returns {Promise} - 返回MainService的Promise对象，包含服务器的响应
 */
export function idpDurationAPI(params) {
  // 定义API的URL路径
  const url = `ddilearner/v1/idp/duration`

  // 发送POST请求到MainService，请求保存指定项目的资源数据
  return request.MainService({
    url: url,
    method: 'post',
    data: params
  });
}




// WEBPACK FOOTER //
// ./src/api/idp.js